import ObjectFilterNull from 'object-filter-null'
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min.js'
import dayjs from 'dayjs'

// import { isNum } from '@/utils/verify'
// 精确校验数据格式方法
export const toType = obj => {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 对象滤空方法
export const filterNull = o => {
  return o ? ObjectFilterNull(o) : o
}

// 获取时间戳（秒）
export const getUnixTime = () => {
  return ~~(+new Date() / 1000)
}

// 获取时间戳（秒）字符串格式
export const getUnixTimeStr = () => {
  return getUnixTime().toString()
}

// 返回手机号加密字符串
export const enMobileNum = mobile => {
  mobile = mobile || ''
  return `${mobile.substring(0, 3)}****${mobile.substring(7)}`
}

// 返回邮箱加密字符串
export const enMailAccount = mail => {
  mail = mail || '***@***.com'
  try {
    const [username, suffix] = mail.split('@')
    const [, domain] = suffix.split('.')
    return `${username.substring(0, 3)}***@***.${domain}`
  } catch (e) {
    return ''
  }
}

// 一维数组转换为二维数组
export const arrTrans = (arr, num) => {
  const iconsArr = [] // 声明数组
  arr.forEach((item, index) => {
    const page = Math.floor(index / num) // 计算该元素为第几个素组内
    if (!iconsArr[page]) { // 判断是否存在
      iconsArr[page] = []
    }
    iconsArr[page].push(item)
  })
  return iconsArr
}

// 判断字符串是否为外链地址
export const isExternal = path => /^(https?:|mailto:|tel:)/.test(path)

// 将字符串复制到剪切板函数
export const copyText = text => {
  return new Promise((resolve, reject) => {
    try {
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      input.parentElement.removeChild(input)
      resolve(text)
    } catch (e) {
      reject(e)
    }
  })
}

// File 转 Blob 函数
export const file2Blob = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = e => {
      let data
      if (toType(e.target.result) === 'arraybuffer') {
        data = window.URL.createObjectURL(new Blob([e.target.result]))
      } else {
        data = e.target.result
      }
      resolve(data)
    }
    reader.readAsArrayBuffer(file)
  })
}

// Blob 转 File 函数
export const blob2File = (blob, fileName = '') => {
  const file = new window.File([blob], fileName, { type: blob.type })
  return file
}

// 睡眠函数
export const sleep = time => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

// 判断是否移动端
export const isMobile = () => {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

// 生成随机UUID
export const makeUUID = () => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const radix = chars.length
  const uuid = []
  for (let i = 0; i < 32; i++) uuid[i] = chars[0 | Math.random() * radix]
  return uuid.join('')
}

export const rsaEn = (str, key) => {
  try {
    const JSE = new JSEncrypt()
    JSE.setPublicKey(key)
    return JSE.encrypt(str)
  } catch (e) {
    return new Error(e)
  }
}

export const formatListTime = (list, format = 'YYYY-MM-DD') => {
  return list.map((i) => {
    i.time = dayjs(i.time).format(format)
    return i
  })
}
export default {
  toType,
  filterNull,
  getUnixTime,
  getUnixTimeStr,
  enMobileNum,
  enMailAccount,
  arrTrans,
  isExternal,
  copyText,
  file2Blob,
  blob2File,
  sleep,
  isMobile,
  makeUUID,
  rsaEn
}
